// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
  },
})
export class NewsPreviewModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public historyBack() {
    this.$router.back();
  }
}
